/** The calendar frame's chrome. */
export default {
  loadingCalendar: "Loading calendar",
  syncingCalendar: "Syncing calendar…",
  noEvents: "No events",
} as const;
